import { useQuery } from "@tanstack/react-query"
import {
  getOrderResultStatistics,
  getResultStatsForPatientIssuer,
} from "../api/statistics"

export const useOrderResultsStatistics = ({
  sortBy,
  patientIssuer,
  from,
  to,
}) =>
  useQuery({
    queryKey: ["order-result-components", sortBy, patientIssuer, from, to],
    queryFn: () =>
      getOrderResultStatistics({ sortBy, patientIssuer, from, to }),
    retry: false,
  })

export const useResultStatsForPatientIssuer = ({ patientIssuer, from, to }) =>
  useQuery({
    queryKey: ["result-stats-for-patient-issuer", patientIssuer, from, to],
    queryFn: () => getResultStatsForPatientIssuer({ patientIssuer, from, to }),
    retry: false,
  })
